import React from 'react'
import PropTypes from 'prop-types'

const AnswerChangeStateDescription = ({ formIsTrackable, stateMessage }) => {
  return (
    <>
      <p className="mt-4 font-bold pb-2">{stateMessage.title}</p>
      {formIsTrackable ? (
        <ul className="list-inside list-disc mb-4">
          {stateMessage.descriptionList.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      ) : (
        <span className="inline-block mb-4">
          La notificación no se enviará; se quedará guardada como historial para uso interno de tu institución.
        </span>
      )}
    </>
  )
}

export default AnswerChangeStateDescription

AnswerChangeStateDescription.propTypes = {
  formIsTrackable: PropTypes.bool,
  stateMessage: PropTypes.object
}
